/* Maison Byōbu · mesure (architecture finale de l'accueil, 01/10, étape e).
   Chaque événement part de trois façons, pour que le pixel branché côté admin choisisse :
   window.dataLayer (event: 'mb_<nom>'), un événement DOM 'mb:mesure' sur document, et
   Shopify.analytics.publish('mb_<nom>') que lit un pixel personnalisé (Réglages > Événements clients).
   Événements : heros_oeuvres, collection_oeuvre (clic sur une œuvre de l'entrée dans la collection), chapitre_vu, chapitre_oeuvre, fiche_ouverte, profondeur (25, 50, 75, 100),
   mise_en_situation, cadreur_ouvert, echantillon, ajout_panier (tentative : envoi du formulaire d'ajout).
   Parcours de découverte de l'accueil (07/10, envoyés par assets/mb-parcours.js) : parcours_question (numero, reponse),
   parcours_resultat (oeuvre, accroche : choisi ou invitation), parcours_decouvrir (oeuvre).
   Aucune donnée personnelle : seulement le nom de l'œuvre, la page et le palier. */
(() => {
  const page = window.mbPage || {};
  const envoyes = new Set();
  function mesure(nom, detail = {}, unique = '') {
    if (unique) { if (envoyes.has(nom + unique)) return; envoyes.add(nom + unique); }
    const d = { page: page.modele || '', ...detail };
    (window.dataLayer = window.dataLayer || []).push({ event: 'mb_' + nom, ...d });
    document.dispatchEvent(new CustomEvent('mb:mesure', { detail: { nom, ...d } }));
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mb_' + nom, d); } catch (e) { /* le pixel n'est pas branché */ }
  }
  window.mbMesure = mesure;

  /* fiche ouverte */
  if (page.modele === 'product' && page.produit) mesure('fiche_ouverte', { produit: page.produit }, page.produit);

  /* clics : héros, lien d'un chapitre, échantillon, « Voir chez moi », cadreur */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a, button');
    if (!a) return;
    const ev = a.getAttribute('data-mb-evenement');
    if (ev === 'heros-oeuvres') mesure('heros_oeuvres');
    if (ev === 'collection-oeuvre') mesure('collection_oeuvre', { oeuvre: a.dataset.oeuvre || '' });
    if (ev === 'chapitre-oeuvre') mesure('chapitre_oeuvre', { oeuvre: a.closest('[data-mb-chapitre]')?.dataset.mbChapitre || '' });
    const href = a.getAttribute('href') || '';
    if (href.includes('/products/echantillon')) mesure('echantillon', { action: 'lien' });
    if (a.hasAttribute('data-vcm-ouvrir')) mesure('mise_en_situation', { produit: page.produit || '' });
    if (href.endsWith('#cadrer')) mesure('cadreur_ouvert', { produit: page.produit || '', action: 'lien' }, 'lien' + href);
  }, true);

  /* cadreur : première interaction avec ses champs */
  document.addEventListener('focusin', (e) => {
    if (e.target.closest && e.target.closest('mb-cadreur')) mesure('cadreur_ouvert', { produit: page.produit || '', action: 'champ' }, 'champ');
  }, true);

  /* ajout au panier : l'envoi du formulaire produit (le cadreur passe aussi par lui) */
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement) || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    const produit = page.produit || '';
    mesure('ajout_panier', { produit });
    if (produit === 'echantillon') mesure('echantillon', { action: 'panier' });
  }, true);

  /* chapitre vu : la suite du chapitre (après l'œuvre en plein écran) entre dans l'écran */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entrees) => {
      entrees.forEach((en) => {
        if (!en.isIntersecting) return;
        const c = en.target.closest('[data-mb-chapitre]');
        mesure('chapitre_vu', { oeuvre: c ? c.dataset.mbChapitre : '' }, c ? c.id : '');
        io.unobserve(en.target);
      });
    });
    document.querySelectorAll('.mb-chapitre__suite').forEach((el) => io.observe(el));
  }

  /* profondeur de défilement : sur ordinateur, Horizon fait défiler .page-wrapper, pas la fenêtre */
  const paliers = [25, 50, 75, 100];
  let prevu = false;
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (prevu || (t !== document && t !== document.documentElement && !(t.classList && t.classList.contains('page-wrapper')))) return;
    prevu = true;
    requestAnimationFrame(() => {
      prevu = false;
      const el = e.target === document || e.target === document.documentElement ? document.scrollingElement : e.target;
      if (!el || !el.scrollHeight) return;
      const course = el.scrollHeight - el.clientHeight;
      if (course < 200) return;
      const pct = (el.scrollTop / course) * 100;
      paliers.forEach((p) => { if (pct >= p - 1) mesure('profondeur', { palier: p }, String(p)); });
    });
  }, { capture: true, passive: true });
})();
